// extracted by mini-css-extract-plugin
export default {"text":"Snineth_text__aRVcx","title":"Snineth_title__d+Kra","desc":"Snineth_desc__uEkKI","Snineth":"Snineth_Snineth__TN7-S","wrap":"Snineth_wrap__whkuT"};